import img from './crumple.mp4';
import text from './text';

export const story = {
    slug: 'crumple',
    title: 'Crumple',
    interactive: 'crumple',
    img: img,
    year: 'Like leaves and paper',
    tags: ['horror'],
    md: text,
}